import { BehaviorSubject } from "rxjs";

const feedbackObjectIsOpen$ = new BehaviorSubject<boolean>(false);
export { feedbackObjectIsOpen$ };
